<template>
  <div class="order-submission">
    <div class="allAddress">
      <div class="nav acea-row">
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
        ></div>
      </div>
      <!-- 选择后的地址 -->
      <div v-if="ifMultiaddress">
        <div
          class="address acea-row row-between-wrapper"
          v-if="shipping_type === 0"
          @click="addressTapOne"
          style="padding:0 .3rem;margin:0 2.7%;"
        >
          <div
            class="addressCon"
            v-if="addressInfo.real_name"
            style="width: 80%;"
          >
            <div class="name">
              {{ addressInfo.real_name }}
              <span class="phone">{{ addressInfo.phone }}</span>
            </div>
            <div>
              <span
                style="padding: 0;"
                class="default font-color-red"
                v-if="addressInfo.is_default"
                >[默认]</span
              >
              {{ addressInfo.province }}{{ addressInfo.city
              }}{{ addressInfo.district }}{{ addressInfo.detail }}
            </div>
          </div>
          <!-- 未选择地址时 -->
          <div class="addressCon" v-else style="width: 80%;">
            <div class="setaddress">设置收货地址</div>
          </div>
          <div class="iconfont icon-jiantou"></div>
        </div>
        <div class="address acea-row row-between-wrapper" v-else>
          <div class="addressCon" style="width: 80%;">
            <div class="name">
              {{ system_store.name }}
              <span class="phone">{{ system_store.phone }}</span>
            </div>
            <div>{{ system_store._detailed_address }}</div>
          </div>
        </div>
        <div class="line" style="padding:0 .3rem;">
          <img src="@assets/images/line.jpg" />
        </div>
      </div>

      <div class="address_btn" @click="addressNum">
        <!-- 设置多个收货地址按钮 -->
        <div style="display: flex;" v-if="ifMultiaddress">
          <img
            src="@assets/images/add_btn.png"
            alt=""
            style="width: .4rem;height: .4rem;"
          />
          <div>
            设置多个收货地址
          </div>
        </div>
        <!-- 设置单个收货地址按钮 -->
        <div style="display: flex;" v-else>
          <img
            src="@assets/images/reduce_btn.png"
            alt=""
            style="width: .4rem;height: .4rem;"
          />
          <div>
            设置一个收货地址
          </div>
        </div>
      </div>
      <!-- 商品选地址 -->
      <div class="productAddress">
        <div class="productAddressDiv">
          <div class="optionalGoodsList">
            <div
              class="OptionalGoodsList"
              :class="i === navActive ? 'on' : ''"
              v-for="(item, i) in goodsType"
              :key="i"
            >
              <div class="typeName">{{ item.type_name }}</div>

              <div
                class="detailItem"
                v-for="(items, index) in item.goods_list"
                :key="index"
              >
                <!-- 商品信息 -->
                <div class="select-btn" v-if="items.is_show == 1">
                  <div style="width: 75%">
                    {{ items.type_name }}
                    <!-- <label class="well-check">
                <span class="def">{{ items.info }}</span>
              </label>-->
                  </div>
                  <div style="width: 15%;text-align: right;">
                    x{{ items.sum }}
                  </div>
                </div>
                <div class="borderLine"></div>
                <!-- 选择后的地址 -->
                <div v-if="!ifMultiaddress">
                  <div
                    class="address acea-row row-between-wrapper"
                    v-if="shipping_type === 0"
                    @click="addressTap(i, index, items)"
                    style="padding: 0;"
                  >
                    <div
                      class="addressCon"
                      v-if="items.addressInfo.real_name"
                      style="width: 80%;"
                    >
                      <div class="name">
                        {{ items.addressInfo.real_name }}
                        <span class="phone">{{ items.addressInfo.phone }}</span>
                      </div>
                      <div>
                        <span
                          style="padding: 0;"
                          class="default font-color-red"
                          v-if="items.addressInfo.is_default"
                          >[默认]</span
                        >
                        {{ items.addressInfo.province
                        }}{{ items.addressInfo.city
                        }}{{ items.addressInfo.district
                        }}{{ items.addressInfo.detail }}
                      </div>
                    </div>
                    <!-- 未选择地址时 -->
                    <div class="addressCon" v-else style="width: 80%;">
                      <div class="setaddress">设置收货地址</div>
                    </div>
                    <div class="iconfont icon-jiantou"></div>
                  </div>
                  <div class="address acea-row row-between-wrapper" v-else>
                    <div class="addressCon" style="width: 80%;">
                      <div class="name">
                        {{ system_store.name }}
                        <span class="phone">{{ system_store.phone }}</span>
                      </div>
                      <div>{{ system_store._detailed_address }}</div>
                    </div>
                  </div>
                </div>

                <div class="line" v-if="!ifMultiaddress">
                  <img src="@assets/images/line.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="limitArea" v-if="limit_area != ''">
      <div style=" width: 21%;color: #e93323;">
        配送提示：
      </div>
      <div style="width:80%;">当前套餐不支持{{ limit_area }}区域下单</div>
    </div>

    <div class="wrapper">
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快递费用</div>
        <div class="discount">免运费</div>
      </div>
      <div v-else>
        <div class="item acea-row row-between-wrapper">
          <div>联系人</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系姓名"
              v-model="contacts"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系电话"
              v-model="contactsTel"
            />
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>紧急联系人</div>
        <div class="discount">
          <input
            style="text-align: right;"
            type="text"
            placeholder="请填写紧急联系人电话"
            v-model="emergency_phone"
          />
        </div>
      </div>
      <div class="item">
        <div>备注信息</div>
        <textarea
          placeholder="请添加备注（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>

    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="settlement2" @click="createOrder">提交订单</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<style scoped>
.typeName {
  text-align: center;
  width: 100%;
  font-size: 16px;
  line-height: 34px;
  font-weight: 700;
  background-color: #fff;
}

.select-btn {
  width: 100% !important;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding-bottom: 0.2rem;
  margin: 0 5%;
}

.productAddress {
  background-color: #fff;
  width: 95%;
  margin: 0 0.2rem;
  padding: 0.1rem;
}

.productAddressDiv {
  width: 100%;
  height: 100%;
  background-color: #f1f2f1;
  padding: 0.1rem;
}

.borderLine {
  width: 100%;
  height: 0.01rem;
  background-color: #d6d6d6;
}

.detailItem {
  padding-top: 0.3rem;
  background-color: #fff;
  margin-bottom: 3px;
}

.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}

.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}

.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #222222 0%, #f5f5f5 70%);
  background-image: -webkit-linear-gradient(to bottom, #222222 0%, #f5f5f5 70%);
  background-image: -moz-linear-gradient(to bottom, #222222 0%, #f5f5f5 70%);
  padding-top: 1rem;
}

.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .allAddress .nav .item {
  width: 3.55rem;
}

.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}

.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "麦麦配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}

.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}

.order-submission .allAddress .nav .item.on2 {
  position: relative;
}

.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "麦麦配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}

.order-submission .allAddress .address {
  height: 1.5rem;
  margin: 0 auto;
  margin: 0 5%;
}

.order-submission .allAddress .line {
  width: 100%;
  margin: 0 auto;
  height: 0.05rem;
}

.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}

.limitArea {
  padding: 0.3rem;
  display: flex;
  background-color: #fff;
}

.address_btn {
  color: #0089ff;
  background-color: #fff;
  padding: 0.2rem 0.3rem;
  margin: 0 0.2rem;
}
</style>
<script>
// import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed } from "@api/order";
import { mapGetters } from "vuex";
// import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
// import { postGoodsCardType ,submitGoodsCard } from "@api/user";
import { postOptionalGoodsCardType } from "@api/user";
import { submitOptionalGoodsCard } from "../../api/user";
const NAME = "SelectGoodsCard",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    // OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  data: function() {
    return {
      emergency_phone: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      goodIndex: 0,
      active: _isWeixin ? "weixin" : "yue",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      goodsType: {},
      navActive: 0,
      checked: [],
      pid: [],
      limit_area: "",
      orderGroupInfoList: [],
      previousPage: "",
      typeIndex: 0,
      isDisabled: false,
      submitTimeout: null,
      ifMultiaddress: true
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {},
  mounted: function() {
    let that = this;
    // that.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
    this.getGoodsType();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$data.previousPage = from.fullPath;
    });
  },
  methods: {
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },

    getGoodsType() {
      console.log(this.$route.query, "ii", this.$route.query.l);
      // 添加新地址时从 localStorage 读取之前选择的数据
      const savedAddresses =
        JSON.parse(localStorage.getItem("goodsType")) || [];

      if (Array.isArray(this.$route.query.l)) {
        this.limit_area = this.$route.query.l.join("、");
      } else if (this.$route.query.l) {
        this.limit_area = this.$route.query.l;
      } else {
        this.limit_area = "";
      }

      let data = {
        group_id: this.$route.query.t,
        number: this.$route.query.u,
        password: this.$route.query.p,
        goodList: JSON.parse(this.$route.query.g)
      };

      let that = this;

      postOptionalGoodsCardType(data)
        .then(function(response) {
          var info = [];
          for (var i = 0; i < response.data.length; i++) {
            for (var j = 0; j < response.data[i]["goods_list"].length; j++) {
              var is_show = 0;
              var sum = 0;
              for (var k = 0; k < data.goodList.length; k++) {
                if (
                  response.data[i]["goods_list"][j]["id"] == data.goodList[k]
                ) {
                  is_show = 1;
                  sum += 1;
                }
              }
              response.data[i]["goods_list"][j]["is_show"] = is_show;
              response.data[i]["goods_list"][j]["sum"] = sum;
            }
          }
          var new_data = [];
          for (var i = 0; i < response.data.length; i++) {
            var new_group = [];
            for (var j = 0; j < response.data[i]["goods_list"].length; j++) {
              if (response.data[i]["goods_list"][j]["is_show"] == 1) {
                new_group.push(response.data[i]["goods_list"][j]);
                new_group[new_group.length - 1].addressInfo = {};
              }
            }
            let expandedGroup = [];
            for (let i = 0; i < new_group.length; i++) {
              const item = new_group[i];
              // 如果sum大于1，则添加多个相同的项，但sum为1
              if (item.sum > 1 && !that.ifMultiaddress) {
                for (let j = 0; j < item.sum; j++) {
                  // 复制对象并设置sum为1
                  expandedGroup.push({ ...item, sum: 1 });
                }
              } else {
                // 如果sum不大于1，则直接添加到新数组中
                expandedGroup.push(item);
              }
            }
            new_data.push({
              goods_list: expandedGroup,
              id: response.data[i].id,
              goods_sum: sum,
              optional_sum: response.data[i].optional_sum,
              type_name: response.data[i].type_name
            });
          }
          if (that.previousPage == "/user/add_address") {
            that.ifMultiaddress = JSON.parse(
              localStorage.getItem("ifMultiaddress")
            );
            if (that.ifMultiaddress) {
              that.addressInfo =
                JSON.parse(localStorage.getItem("addressInfo")) || {};
              that.goodsType = savedAddresses;
            } else {
              that.goodsType = savedAddresses;
            }
            localStorage.removeItem("ifMultiaddress");
          } else {
            that.goodsType = new_data;
            localStorage.setItem("goodsType", JSON.stringify(new_data));
          }
        })
        .catch(function(e) {
          console.log(e);
        });
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1
      }).then(res => {
        const data = res.data;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;
        }
      });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.computedPrice();
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    addressTap: function(i, index, items) {
      this.typeIndex = i;
      this.goodIndex = index;
      this.showAddress = true;
      this.addressInfo = items.addressInfo;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressTapOne: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    // 切换多地址/单地址
    addressNum() {
      this.ifMultiaddress = !this.ifMultiaddress;
      localStorage.setItem(
        "ifMultiaddress",
        JSON.stringify(this.ifMultiaddress)
      );
      this.previousPage = "/";
      if (Array.isArray(this.goodsType) && !this.ifMultiaddress) {
        this.goodsType = this.goodsType.map(goodsTypeItem => ({
          ...goodsTypeItem,
          goods_list: goodsTypeItem.goods_list.map(goodItem => ({
            ...goodItem,
            addressInfo: {}
          }))
        }));
        localStorage.setItem("goodsType", JSON.stringify(this.goodsType));
      }
      this.addressInfo = {};
      this.getGoodsType();
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
    },

    asideTap: function(index) {
      this.navActive = index + ",";
      // this.$dialog.toast({ mes: "选择:"+index });
      console.log(index);
    },
    changeAddress(addressInfo) {
      localStorage.setItem(
        "ifMultiaddress",
        JSON.stringify(this.ifMultiaddress)
      );
      if (!this.ifMultiaddress) {
        this.goodsType[this.typeIndex].goods_list[
          this.goodIndex
        ].addressInfo = addressInfo;
        localStorage.setItem("goodsType", JSON.stringify(this.goodsType));
      } else {
        this.addressInfo = addressInfo;
        localStorage.setItem("addressInfo", JSON.stringify(this.addressInfo));
      }
    },
    checkStatus(id, e) {
      console.log(id);
      console.log(this.checked);
      //当前选中商品id串
      let checkedID = this.checked;
      //checkbox选中状态
      let status = e.target.checked;
      if (status) {
        this.pid.push(id);
        console.log(this.pid);
      } else {
        this.pid.splice(this.pid.findIndex(item => item === id), 1);
        console.log(this.pid);
      }
    },
    createOrder() {
      let selected_goods_list = [];
      if (this.ifMultiaddress) {
        if (!this.addressInfo.id && !this.shipping_type)
          return this.$dialog.toast({ mes: "请选择收货地址" });
        let goods_list = Object.keys(this.goodsType).reduce((result, key) => {
          if (this.goodsType[key].goods_list) {
            return result.concat(this.goodsType[key].goods_list);
          }
          return result;
        }, []);
        selected_goods_list = goods_list.reduce((acc, item) => {
          // 如果 sum 存在且大于 1，则生成 sum 个对象
          if (item.sum && item.sum > 1) {
            for (let i = 0; i < item.sum; i++) {
              acc.push({
                goods_id: item.id,
                address_id: this.addressInfo.id || null
              });
            }
          } else {
            acc.push({
              goods_id: item.id,
              address_id: this.addressInfo.id || null
            });
          }
          return acc;
        }, []); // 初始累加器是一个空数组
      } else {
        // 把商品低跟地址id组合起来
        let goods_list = Object.keys(this.goodsType).reduce((result, key) => {
          if (this.goodsType[key].goods_list) {
            return result.concat(this.goodsType[key].goods_list);
          }
          return result;
        }, []);
        let hasMissingAddressId = false;
        selected_goods_list = goods_list.map(item => {
          if (!item.addressInfo || !item.addressInfo.id) {
            hasMissingAddressId = true;
            return {
              goods_id: item.id,
              address_id: null
            };
          }
          return {
            goods_id: item.id,
            address_id: item.addressInfo.id
          };
        });
        console.log(
          selected_goods_list,
          "selected_goods_listselected_goods_listselected_goods_list"
        );
        // 检查是否有缺失的address_id
        if (hasMissingAddressId && !this.shipping_type) {
          return this.$dialog.toast({ mes: "请选择所有商品的收货地址" });
        }
      }

      if (!this.emergency_phone) {
        return this.$dialog.toast({ mes: "请输入紧急联系人电话" });
      } else {
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.emergency_phone)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
      }
      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }
      if (this.isDisabled) {
        // 如果按钮被禁用，则不执行后续操作
        return;
      }
      // 禁用按钮，防止在1秒内再次点击
      this.isDisabled = true;
      clearTimeout(this.submitTimeout);
      // 设置一个1秒后的计时器来重新启用按钮
      this.submitTimeout = setTimeout(() => {
        this.isDisabled = false;
      }, 2000);
      this.$dialog.loading.open("生成订单中");

      let that = this;
      if (this.goodsType[this.navActive].id.length == 0) {
        that.$dialog.loading.close();
        that.$dialog.toast({ mes: "套餐类型错误，请检查后重试！" });
      } else {
        let data = {
          group_id: this.$route.query.t,
          number: this.$route.query.u,
          password: this.$route.query.p,
          type_id: this.goodsType[this.navActive].id,
          addressId: this.addressInfo.id,
          mark: this.mark,
          selected_goods_list: selected_goods_list,
          emergency_phone: this.emergency_phone
        };
        submitOptionalGoodsCard(data)
          .then(function(response) {
            console.log(response);
            that.$dialog.loading.close();
            that.$dialog.toast({
              mes: "兑换成功，我们将尽快为您排单发货。"
            });
            that.$router.replace({ path: "/user/active_goods_card/" });
          })
          .catch(function(e) {
            that.$dialog.loading.close();
            console.log(e);
            that.$dialog.toast({ mes: "兑换失败，" + e.msg });
          });
      }
    }
  }
};
</script>
